jQuery(function() {
    //IE11 Detection
    var IE11 = !!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/));;
    if(IE11 === true){
        $('html').addClass('IE11');
    }

    //Product Page Item description collapse and tabs
    $(function () {
        $("#tabs > div").hide();
        $("#tabs > div:first").show();
        $("#tabs > span.tab-buttons button:first").addClass("active");
        $("#tabs > span.tab-buttons button").on("click", function () {
        $("#tabs > span.tab-buttons button").attr("class", "");
        $("#tabs > span.tab-buttons button").attr("tabindex", "-1");
        $("#tabs > span.tab-buttons button").attr("aria-selected", "false");
        $(this).attr("class", "active");
        $(this).attr("tabindex", "0");
        $(this).attr("aria-selected", "true");
        var currentTab = $(this).attr("aria-controls");
        $("#tabs > div").hide();
        $(`#${currentTab}`).show();
        return false;
        });
    });
    $(window).on('load', function () {
        $('.item-image, .slider').flexslider({
            animation: "slide",
            animationLoop: false,
            useCSS: false
        });
    });
    /*Pinned Header */
    checkOffset();
    $(window).on('scroll', function() {
        checkOffset();
    });
    function checkOffset() {
        if ( window.scrollY > 0){
            $('header').addClass('fixed');
        } else {
            $('header').removeClass('fixed');
        }
    }

    // ADA AAA
    var $dropdowns = $("#main-nav .dropdown");
    var $dropdownsLinks = $("#main-nav .dropdownLink");
    $dropdownsLinks.on("focus",function(){
        let $thisParent = $(this).parent();
        $dropdowns.removeClass("open");
        $dropdownsLinks.attr("aria-expanded", "false");
        $thisParent.addClass("open");
        $(this).attr("aria-expanded", "true");
    })
    $('.menu-overlay').on("focusout", function() {
        setTimeout(() => {
            // if active element is outside the div.menu-overlay...
            if ($(document.activeElement).parents('.menu-overlay').length === 0) {
            // remove hover functionality
                $dropdowns.removeClass("open");
            }
        }, 100)
    })
    $('#main-nav').on("focusout", function() {
        setTimeout(() => {
          // if active element is outside the div.header-container...
          if ($(document.activeElement).parents('#main-nav').length === 0) {
            // remove hover functionality
            $dropdowns.removeClass("open");
            $dropdownsLinks.attr("aria-expanded", "false");
          }
        }, 100);
    })
    if (document.body.classList.contains("pghome")) {
        function checkWidth() {
            var viewportWidth = document.documentElement.clientWidth;
            if (viewportWidth < 768) {
                
            } else {
                
            } 
        }
        checkWidth();
        window.addEventListener("resize", function(){
            checkWidth();
        });
    } 
}); 




